import $ from 'jquery';

const JS_PREFIX = 'js-nav';

class Nav {
  dom = {
    $nav: null,
    $arrows: null,
    $firstLis: null
  }


  constructor() {
    this.dom.$nav = $(`#${JS_PREFIX}`);
  }

  activateSubToggles() {
    const self = this;
    this.dom.$subToggles = this.dom.$nav.find(`.${JS_PREFIX}__sub-toggle`);

    this.dom.$subToggles.on('click', function (e) {
      e.preventDefault();

      const $toggle = $(this);
      const $parentLi = $toggle.closest(`.${JS_PREFIX}__li`);

      if($parentLi.hasClass('is-open')) {
        $parentLi.removeClass('is-open');
      } else {
        $parentLi.addClass('is-open');
      }

      // Fix for iOS that doesn't trigger overflow scrolling when using height transitions, so we force recalculations
      $parentLi.find(`.${JS_PREFIX}__ul:first`).one('transitionend', () => {
        self.dom.$nav.css({ height: (self.dom.$nav.height() + 1) + 'px' });
        self.dom.$nav[0].offsetHeight;
        self.dom.$nav.css({ height: '' });
      });
    })
  }

  activateDropdown() {
    const self = this;

    this.dom.$firstLis = this.dom.$nav.find(`.${JS_PREFIX}__ul--level-0 > .${JS_PREFIX}__li.has-children`);
    this.dom.$arrows = this.dom.$nav.find(`.${JS_PREFIX}__arrow`);

    this.dom.$firstLis.on('mouseover', function (e) {
      // Disable in mobile to prevent click bugs
      if(!self.dom.$nav.hasClass('has-toggled-menu')) {
        const $li = $(this);
        const position = $li.position();

        // Move arrows to currently hovered nav item
        if(position) {
          const left = position.left;
          const liCenter = $li.width() / 2;

          self.dom.$arrows.css({
            transform: `translateX(${parseInt(left + liCenter)}px)`
          });
        }

        if(!self.dom.$nav.hasClass('has-activated-dropdowns')) {
          // Add class after first transforms have been applied
          setTimeout(() => {
            self.dom.$nav.addClass('has-activated-dropdowns');
          }, 0);
        }
      }
    });

  }

  init() {
    if(!this.dom.$nav.length) {
      return;
    }

    this.activateDropdown();
    this.activateSubToggles();
  }
}

const nav = new Nav();

export default nav;
